<h2 mat-dialog-title>{{ data?.id ? ("product.dialog_title_edit" | transloco) : ("product.dialog_title_create" | transloco) }}</h2>
<mat-divider></mat-divider>
<br />
<mat-dialog-content>
    <form [formGroup]="form" autocomplete="off" novalidate>
        <mat-form-field class="full-width">
            <mat-label>ISBN</mat-label>
            <input matInput formControlName="isbn" />
            @if (form.get("isbn")?.hasError("regex")) {
                <mat-error>{{ "product.isbn_invalid" | transloco }}</mat-error>
            }
            @if (form.get("isbn")?.hasError("unique")) {
                <mat-error>{{ "product.isbn_duplicate" | transloco }}</mat-error>
            }
        </mat-form-field>
        &nbsp;
        <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" />
        </mat-form-field>

        <h3>{{ "product.imprint" | transloco }}</h3>
        <pixl-editor
            class="full-width"
            [htmlString]="form.get('imprint')?.value"
            [bearerToken]="authToken!"
            [assetUrl]="assetsUrl"
            [mediaUrl]="mediaUrl"
            editorHeight="100%"
            (editedHtmlStringChange)="form.patchValue({ imprint: $event })"
        >
        </pixl-editor>
    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <button mat-button (click)="cancel()">{{ "cancel" | transloco }}</button>
    <button mat-raised-button color="primary" (click)="save()">{{ "save" | transloco }}</button>
</mat-dialog-actions>
